import {MenuCreateOptionInterface} from 'kernel/types/module'
class menu {
  private vm: Vue
  constructor() {
    this.vm = window.rootVm
  }

  $t(args: string) {
    return this.vm.$t(args)
  }

  get() : {[key: string]: any} {
    return {
      admin: [
        {
          label: this.vm.$t('page.store'),
          icon: 'fa fa-info-circle',
          create: (options: MenuCreateOptionInterface) => options.hasRole(['ROLE_STORE']),
          group: [
            {
              label: this.vm.$t('page.store'),
              route: {
                name: 'store',
              },
            }
          ],
        },
      ],
    }
  }
}

export default () => (new menu()).get()
